// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const buildClassName = (name, clickable) =>
    `badge ${name} ${clickable ? 'clickable' : ''}`;

const Badge = props =>
    <div
        className={buildClassName(props.className, props.clickable)}
        onClick={props.clickable ? props.onClick : null}
    >
        {props.translate ?
            <FormattedMessage
                id={props.text}
            /> : <span>{props.text}</span>
        }
    </div>;

Badge.displayName = 'Badge';
Badge.propTypes = {
    className: PropTypes.string.isRequired,
    clickable: PropTypes.bool.isRequired,
    onClick: PropTypes.func,
    text: PropTypes.string.isRequired,
    translate: PropTypes.bool.isRequired
};

Badge.defaultProps = {
    clickable: false,
    onClick: null
};

export default Badge;



// WEBPACK FOOTER //
// ./src/shared/components/badge.js